export class DomainError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DomainError';
  }
}

export class ValidationError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class StockError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'StockError';
  }
}

export class MovementError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'MovementError';
  }
}

export class ValueObjectError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'ValueObjectError';
  }
}

export class InsufficientStockError extends StockError {
  constructor(
    public readonly productId: string,
    public readonly requested: number,
    public readonly available: number,
    public readonly warehouseId?: string,
  ) {
    super(
      `Insufficient stock for product ${productId}: requested ${requested}, available ${available}`
    );
    this.name = 'InsufficientStockError';
  }
}